import mem from 'mem';
import { axiosPublic } from './axiosPublic';

// eslint-disable-next-line consistent-return
const refreshTokenFn = async () => {
  const userInformation = JSON.parse(localStorage.getItem('userInfo'));

  try {
    const response = await axiosPublic.post('token/refresh/', {
      refresh: userInformation?.refresh,
    });
    const { access, refresh } = response.data;

    if (!access) {
      localStorage.removeItem('userInfo');
    }

    userInformation.access = access;
    userInformation.refresh = refresh;
    localStorage.setItem('userInfo', JSON.stringify(userInformation));

    return access;
  } catch (error) {
    localStorage.removeItem('userInfo');
  }
};

const maxAge = 600000;
export const memoizedRefreshToken = mem(refreshTokenFn, {
  maxAge,
});
